import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Seq } from 'immutable';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppState } from 'src/store/appstate';
import { selectCardLinksByRendezvousRequestId } from 'src/store/entityStores/card-link-selectors';
import { RendezvousRequestEntityFetchService } from 'src/store/generated/client-sync.generated';
import {
  RendezvousRequestRecord,
  RendezvousRequestViewModelBase,
} from 'src/store/generated/rendezvous-request-record.generated';
import { undefinedOrMap } from 'src/util/rxjs/operators';

export class RendezvousRequestViewModel extends RendezvousRequestViewModelBase {
  public cardLinkIds$: Observable<Seq.Indexed<string>>;
  public cardLinkCardNumbers$: Observable<Seq.Indexed<string>>;

  get canConfirm() {
    return this.confirmedAt == null;
  }

  get canDepartLz() {
    return this.confirmedAt != null && this.departedLzAt == null;
  }

  get canArriveDest() {
    return this.departedLzAt != null && this.arrivedDestAt == null;
  }

  get canDepartDest() {
    return this.arrivedDestAt != null && this.departedDestAt == null;
  }

  get canArriveLz() {
    return this.departedDestAt != null && this.arrivedLzAt == null;
  }

  get isConfirmed() {
    return this.confirmedAt != null;
  }

  get hasDepartedLz() {
    return this.departedLzAt != null;
  }

  get hasArrivedAtDest() {
    return this.arrivedDestAt != null;
  }

  get hasDepartedDest() {
    return this.departedDestAt != null;
  }

  get hasArrivedAtLz() {
    return this.arrivedLzAt != null;
  }

  constructor(rendezvousRequestRecord: RendezvousRequestRecord, private _store: Store<AppState>) {
    super(rendezvousRequestRecord);

    this.cardLinkIds$ = _store
      .select(selectCardLinksByRendezvousRequestId(rendezvousRequestRecord.id))
      .pipe(map((cardLinks) => cardLinks.map((cl) => cl.id)));

    this.cardLinkCardNumbers$ = _store
      .select(selectCardLinksByRendezvousRequestId(rendezvousRequestRecord.id))
      .pipe(map((cardLinks) => cardLinks.map((cardLink) => cardLink.toCardNumber)));
  }
}

@Injectable({ providedIn: 'root' })
export class RendezvousRequestViewModelService {
  constructor(
    private _entity: RendezvousRequestEntityFetchService,
    private _store: Store<AppState>,
  ) {}

  public getById(id: string): Observable<RendezvousRequestViewModel | undefined> {
    return this._entity
      .getById(id)
      .pipe(undefinedOrMap((rr) => new RendezvousRequestViewModel(rr, this._store)));
  }
}
